import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import GetAccountBillURL from "../../graphql/GetAccountBillURL.graphql";
import actions, { bindData } from "../../../renderer/actions";
import { getClientSlug, getWorkflowSubClient } from "../../../util/state";
import { listViewHasBillUrlColumn } from "../../../renderer/utils";
import { createQuery } from "../../../util/graphql";

// 10s gives slow source systems enough room to respond. The listview renders before
// this fetch starts, so users are not blocked while waiting.
const BILL_URL_TIMEOUT_MS = 10000;
const NOT_AVAILABLE = "Not Available";

const getBillUrlConfig = state => {
  const clientSlug = getClientSlug(state);
  const subClientSlug = getWorkflowSubClient(state);
  const endpoint = state.config.graphqlServiceEndpoint;
  return clientSlug && subClientSlug && endpoint
    ? { clientSlug, subClientSlug, endpoint }
    : null;
};

const fetchBillUrl$ = (obligation, clientSlug, subClientSlug, endpoint) => {
  // obligation.description holds the account ID, populated by extractObligations
  // in lookup.js from the obligation's "term" custom attribute.
  const accountId = obligation.description;
  if (!accountId) {
    return Rx.of({ ...obligation, bill_url: NOT_AVAILABLE });
  }

  return Rx.from(
    createQuery(endpoint, clientSlug)(GetAccountBillURL, {
      accountId,
      clientSlug,
      subClientSlug
    })
  ).pipe(
    RxOp.timeout(BILL_URL_TIMEOUT_MS),
    RxOp.map(response => ({
      ...obligation,
      bill_url: response?.getAccountBillUrl?.url ?? NOT_AVAILABLE
    })),
    RxOp.catchError(() => Rx.of({ ...obligation, bill_url: NOT_AVAILABLE }))
  );
};

export const fetchObligationBillUrlsEpic = (action$, state$) =>
  action$.ofType(actions.FETCH_OBLIGATION_BILL_URLS).pipe(
    RxOp.switchMap(({ payload: { obligations, resultsLocation } }) => {
      const state = state$.value;
      const config = getBillUrlConfig(state);

      if (!listViewHasBillUrlColumn(state) || !obligations.length || !config) {
        return Rx.empty();
      }

      const { clientSlug, subClientSlug, endpoint } = config;

      return Rx.forkJoin(
        obligations.map(obl =>
          fetchBillUrl$(obl, clientSlug, subClientSlug, endpoint)
        )
      ).pipe(
        RxOp.map(enrichedObligations =>
          bindData({ location: resultsLocation, data: enrichedObligations })
        ),
        RxOp.catchError(() => Rx.empty())
      );
    }),
    RxOp.catchError((err, source$) => {
      console.error("fetchObligationBillUrlsEpic unhandled error", err);
      return source$;
    })
  );
